import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_USU_PROFESIONES,
  ALL_USU_PROFESIONES,
  LOADING_ALL_USU_PROFESIONES,
} from './UsuProfesionesReducer';
import {
  allUsuProfesionesService,
  deleteUsuProfesionesService,
  saveUsuProfesionesService,
} from './UsuProfesionesService';

export const allUsuProfesionesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_USU_PROFESIONES, payload: true });
    const res = await allUsuProfesionesService(params);
    dispatch({ type: ALL_USU_PROFESIONES, payload: res.data });
    dispatch({ type: LOADING_ALL_USU_PROFESIONES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_USU_PROFESIONES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveUsuProfesionesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveUsuProfesionesService(id, data);
    notify(res.data.message);
    await allUsuProfesionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoUsuProfesionesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_USU_PROFESIONES, payload: data });
};

export const deleteUsuProfesionesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteUsuProfesionesService(id);
    notify(res.data.message);
    await setActivoUsuProfesionesAction(dispatch, null);
    await allUsuProfesionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
